// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f79cbe75","977":"63d489c0"}[chunkId] + ".chunk.js";
};